const gridView = `
<svg width="33px" height="33px" viewBox="0 0 33 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="C.1.3---Pipeline-Hub---List-Open" transform="translate(-929.000000, -495.000000)" stroke="#783C96">
            <rect shape-rendering="geometricPrecision" id="Rectangle-6" x="930" y="496" width="31" height="31" rx="15.5"></rect>
            <g id="Group" transform="translate(937.000000, 506.000000)" stroke-linejoin="round" stroke-width="5">
                <path d="M0,1.5 L6.84000015,1.5" id="Stroke-1166"></path>
                <path d="M10,1.5 L16.8400002,1.5" id="Stroke-1166-Copy"></path>
                <path d="M0,9.5 L6.84000015,9.5" id="Stroke-1166-Copy-3"></path>
                <path d="M10,9.5 L16.8400002,9.5" id="Stroke-1166-Copy-4"></path>
            </g>
        </g>
    </g>
</svg>`;

const listView = `
<svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="C.1.1---Pipeline-Hub---Grid" transform="translate(-1055.000000, -498.000000)" stroke="#783C96">
            <g id="Icon-/-View-/-List-/-Inactive" transform="translate(1056.000000, 499.000000)">
                <rect shape-rendering="geometricPrecision" id="Rectangle-6" x="0" y="0" width="32" height="32" rx="16"></rect>
                <g id="Group" fill-rule="evenodd" transform="translate(6.956522, 11.826087)" stroke-linejoin="round">
                    <path d="M0,0.695652174 L18.2636289,0.695652174" id="Stroke-1166-Copy-2" stroke-width="4"></path>
                    <path d="M0,7.65217391 L18.2636289,7.65217391" id="Stroke-1166-Copy-5" stroke-width="4"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;

const downCarrot = (color = '#0091C8') => `
<svg width="23px" height="15px" viewBox="0 0 23 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="Accordion-/-Policy-Domain-/-Inactive" transform="translate(-1109.000000, -42.000000)" stroke="${color}">
            <g id="Button-/-Accordion-/-Open-/-Blue" transform="translate(1109.000000, 42.000000)">
                <path d="M11.5,0.5 L0.5,14.5" id="Line-Copy-4" transform="translate(6.000000, 7.500000) scale(1, -1) translate(-6.000000, -7.500000) "></path>
                <path d="M22.5,0.5 L11.5,14.5" id="Line-Copy-5" transform="translate(17.000000, 7.500000) scale(-1, -1) translate(-17.000000, -7.500000) "></path>
            </g>
        </g>
    </g>
</svg>`;

const close = `
<svg width="27px" height="25px" viewBox="0 0 27 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="H.1.3---Performance-Report-Hub---Filter-by-Year" transform="translate(-1257.000000, -413.000000)" stroke="#3C5064">
            <g id="Group-2" transform="translate(1258.000000, 413.000000)">
                <path d="M24.4711914,0 L0.298507448,24.172684" id="Line-Copy-5" transform="translate(12.500000, 12.500000) scale(-1, -1) translate(-12.500000, -12.500000) "></path>
                <path d="M24.4711914,0 L0.298507448,24.172684" id="Line-Copy-6" transform="translate(12.500000, 12.500000) scale(1, -1) translate(-12.500000, -12.500000) "></path>
            </g>
        </g>
    </g>
</svg>`;

const search = `
<svg width="27px" height="28px" viewBox="0 0 27 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="H.1.4---Performance-Report-Hub---Filter-by-Year-Active" transform="translate(-1168.000000, -413.000000)" stroke="#253444">
            <g id="Group-2" transform="translate(1169.000000, 414.000000)">
                <path d="M16,17 L25.3333333,26.3333333" id="Stroke-4164"></path>
                <path d="M9.5,19 C4.25315,19 0,14.74685 0,9.5 C0,4.25315 4.25315,0 9.5,0 C14.74685,0 19,4.25315 19,9.5 C19,14.74685 14.74685,19 9.5,19 Z" id="Stroke-4165"></path>
            </g>
        </g>
    </g>
</svg>`;

const blueArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10">
<g fill="none" fill-rule="evenodd" stroke="#3C5064" transform="rotate(-180 7 5)">
  <path stroke-linejoin="round" d="M0.488456983,5 L7.42482528,5"/>
  <polygon points="6.412 2.281 10.477 7.735 14.723 2.281" transform="rotate(-90 10.567 5.008)"/>
</g>
</svg>
`;

const closeX = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 27 25" version="1.1" class="close-x" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <title>Group 2</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="H.1.3---Performance-Report-Hub---Filter-by-Year" transform="translate(-1257.000000, -413.000000)" stroke="#3C5064">
            <g id="Group-2" transform="translate(1258.000000, 413.000000)">
                <path d="M24.4711914,0 L0.298507448,24.172684" id="Line-Copy-5" transform="translate(12.500000, 12.500000) scale(-1, -1) translate(-12.500000, -12.500000) "></path>
                <path d="M24.4711914,0 L0.298507448,24.172684" id="Line-Copy-6" transform="translate(12.500000, 12.500000) scale(1, -1) translate(-12.500000, -12.500000) "></path>
            </g>
        </g>
    </g>
</svg>`;

const rightArrowCircle = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="35px" height="36px" viewBox="0 0 35 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Breakpoints" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Approach-Page---Mobile" transform="translate(-12.000000, -232.000000)" stroke="#3C5064">
            <g id="Left-Menu" transform="translate(0.000000, 219.000000)">
                <g id="Button-/-Circle-Arrow-/-Reading-Menu-/-Inactive" transform="translate(29.500000, 31.000000) scale(-1, 1) translate(-29.500000, -31.000000) translate(13.000000, 14.000000)">
                    <g id="Button-/-Circle-Arrow-/-Inactive" transform="translate(16.500000, 17.000000) rotate(-180.000000) translate(-16.500000, -17.000000) ">
                        <g id="Group">
                            <rect id="Rectangle-6" x="0" y="0" width="33" height="34" rx="16.5"></rect>
                            <path d="M9.48845698,17.5151515 L16.4248253,17.5151515" id="Stroke-1166" stroke-linejoin="round"></path>
                            <polygon id="Stroke-1430" transform="translate(19.726817, 18.198434) rotate(-90.000000) translate(-19.726817, -18.198434) " points="15.5716672 15.3889857 19.6364426 21.0078816 23.881967 15.3889857"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

const triangleHead = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51 (57462) - http://www.bohemiancoding.com/sketch -->
    <title>Stroke 1430</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-/-Blue-Arrow" transform="translate(-21.000000, 0.000000)" stroke="#0091C8">
            <g id="Group">
                <path d="M19.5087039,3 L25.3563353,10.6855437 L31.4639942,3 L19.5087039,3 Z" id="Stroke-1430" transform="translate(25.500000, 7.000000) rotate(-90.000000) translate(-25.500000, -7.000000) "></path>
            </g>
        </g>
    </g>
</svg>`;

export {
  gridView,
  listView,
  downCarrot,
  close,
  search,
  blueArrow,
  closeX,
  rightArrowCircle,
  triangleHead,
};
